export default __webpack_public_path__ + "a562f462c359316a9eecda0e5a6da74f.png";